import { useDispatch, useSelector } from "react-redux";
import { loginAction, logoutAction, removeTokenAction } from "./sessaoActions";
import { SessaoState } from "./sessaoTypes";
import { RootAppState } from "../store";
import authApi from "../../api/authApi";

export const useSessao = (): [
  SessaoState,
  (username: string, senha: string, browserID?: string) => Promise<void>,
  () => Promise<void>
] => {
  const sessao = useSelector((state: RootAppState) => state.sessao);

  const dispatch = useDispatch();
  const login = async (username: string, senha: string, browserID?: string) => {
    const sessao = await authApi.login(username, senha);
    const action = loginAction(sessao);

    dispatch(action);
  };

  const logout = async () => {
    const action = logoutAction();
    dispatch(action);
    // const limparPedido = limparTudoPMAction();
    // dispatch(limparPedido);

    const limparToken = removeTokenAction();
    dispatch(limparToken);
  };

  return [sessao, login, logout];
};

// export const useVendedorSessao = () => {
//   const [sessao] = useSessao();
//   return sessao.usuario?.vendedor;
// };
